import { BaseCard } from '@/components/uiKit/Cards/BaseCard';
import React, { ReactNode } from 'react';

interface AssetsPreviewCardProps {
  children: ReactNode;
  title: string;
}

export const AssetsPreviewCard = ({ children, title }: AssetsPreviewCardProps) => {
  return (
    <BaseCard variant="wrapper" title={title} classNames={{ content: 'p-0 bg-inherit' }}>
      {children}
    </BaseCard>
  );
};
